import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormStateService {
  private isFormDirty: boolean = false;

  setFormState(isDirty: boolean): void {
    this.isFormDirty = isDirty;
  }

  getFormState(): boolean {
    return this.isFormDirty;
  }
}
